import { SWAN_STYLE_KEY_MAP } from '@vp/swan';

var REACT_COMP_VERSION = "v10";
var BOOKENDS_META_TAG_NAME = "bookendSlugs";
var BOOKEND_TYPES = {
    FULL: "full",
    SLIM: "slim",
};
var BOOKENDS_SWAN_STYLES = [
    SWAN_STYLE_KEY_MAP.button,
    SWAN_STYLE_KEY_MAP.accordion,
    SWAN_STYLE_KEY_MAP.grid,
    SWAN_STYLE_KEY_MAP.modalDialog,
    SWAN_STYLE_KEY_MAP.hidden,
    SWAN_STYLE_KEY_MAP.icon,
    SWAN_STYLE_KEY_MAP.toggleSwitch,
    SWAN_STYLE_KEY_MAP.core,
    SWAN_STYLE_KEY_MAP.visible,
    SWAN_STYLE_KEY_MAP.standardTile,
    SWAN_STYLE_KEY_MAP.progressiveImage,
    SWAN_STYLE_KEY_MAP.listbox,
    SWAN_STYLE_KEY_MAP.popover,
];

export { BOOKENDS_META_TAG_NAME, BOOKENDS_SWAN_STYLES, BOOKEND_TYPES, REACT_COMP_VERSION };
//# sourceMappingURL=constants.js.map
